/**
 * LEN0X MEMBER — canonical Experience Module display catalog.
 *
 * These keys identify OPS ClubFeature entries, not addon permissions.
 * Importing this file cannot register or enable any feature.
 */
export const MEMBER_EXPERIENCE_MODULES = Object.freeze([
  Object.freeze(["member_app", "Member App", "Öffentliche Club-App und Bootstrap"]),
  Object.freeze(["push", "Push", "Direkter Clubkontakt"]),
  Object.freeze(["community_chat", "Community Chat", "Getrennter Member-Chat"]),
  Object.freeze(["dating", "Connections", "Privater Opt-in-Bereich"]),
  Object.freeze(["goodies", "Goodies", "Vorteile und Einlösung"]),
  Object.freeze(["drink_lab", "Drink Lab", "Geschmacksbasierter Mixer"]),
  Object.freeze(["table_games", "Tischspiele", "Sessions für 2–6 Personen"]),
  Object.freeze(["game_controller", "Controller", "PAD- und Touchfeld-Modus"]),
  Object.freeze(["jukebox", "Jukebox", "Trackwünsche und Challenges"]),
  Object.freeze(["easter_eggs", "Easter Eggs", "Versteckte Clubmomente"]),
]);

export const MEMBER_EXPERIENCE_KEYS = Object.freeze(
  MEMBER_EXPERIENCE_MODULES.map(([key]) => key)
);
